import { render, staticRenderFns } from "./BindCard.vue?vue&type=template&id=ad7579f4&scoped=true"
import script from "./BindCard.vue?vue&type=script&lang=js"
export * from "./BindCard.vue?vue&type=script&lang=js"
import style0 from "./BindCard.vue?vue&type=style&index=0&id=ad7579f4&prod&lang=less&scoped=true"
import style1 from "./BindCard.vue?vue&type=style&index=1&id=ad7579f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7579f4",
  null
  
)

export default component.exports